<app-splash-screen></app-splash-screen>
<button
  *ngIf="!isChatOpen && isSplashScreenLoaded.value"
  (click)="toggleChat()"
  class="help-btn border-none inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 hover:bg-primary/90 h-14 w-14 rounded-full bg-primary text-primary-foreground shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 animate-float"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-message-circle h-6 w-6"
  >
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
  </svg>
</button>

<div
  *ngIf="isChatOpen"
  class="card position-fixed"
  style="bottom: 20px; right: 20px; width: 350px; box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.12);z-index: 99999;"
>
  <div
    class="flex-wrap align-content-center card-header d-flex justify-content-between rounded bg-primary h-20px"
  >
    <span class="text-white" style="margin-top: 12px"
      >Suporte
      <span
        _ngcontent-xmn-c496=""
        class="badge badge-pill badge-primary"
        style="margin-left: 5px; background-color: #7a84ce"
        >BETA</span
      ></span
    >
    <button
      class="btn"
      (click)="toggleChat()"
      style="left: 29px; position: relative"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="white"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-x h-4 w-4"
      >
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
  </div>
  <div #scrollContainer class="card-body" style="height: 300px; overflow-y: auto">
    <div *ngFor="let msg of messages">
      <div
        [ngClass]="{
          user: msg.from === 'user',
          '': msg.from === 'bot'
        }"
      >
        <div
          [ngClass]="{
            'user-message': msg.from === 'user',
            'bot-message': msg.from === 'bot'
          }"
        >
          <span>{{ msg.text }}</span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="this.isTyping.value">
      <i class="fas fa-ellipsis-h typing-icon"></i>
    </ng-container>
  </div>
  <div class="p-4 border-t">
    <div class="flex gap-2 d-flex justify-content-between">
      <input
        style="width: 283px"
        class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm flex-1"
        placeholder="Digite sua pergunta..."
        value=""
        [(ngModel)]="userMessage"
        (keyup.enter)="sendMessage()"
      /><button
        class="p-top-2px border-none rounded inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 bg-primary text-primary-foreground hover:bg-primary/90 h-10 w-10 shrink-0"
        (click)="sendMessage()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"
          ></path>
          <path d="m21.854 2.147-10.94 10.939"></path>
        </svg>
      </button>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
